import { defineMessages } from 'react-intl';

export const messages: {
	ai_answer_followup_see_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ai_answer_followup_see_more: {
		id: 'search_ai.followup_see_more',
		defaultMessage: 'See more',
		description:
			'Button label to reveal additional follow-up suggestion pills in the smart answer footer.',
	},
});
